module.exports = __webpack_public_path__ + "973d5fe009aeab564a6ff4b9da9f8137.svg";